<script>
  export let url = false, index = false, callback = false, unsetModal = false, width = 960, height = 540

  function closeModal(){
    let modal = document.querySelector('[data-modal]')
    let player = document.getElementById('player')

    modal.classList.add('opacity-0')

    setTimeout(() => {
	    modal.classList.add('hidden')
	    modal.classList.remove('opacity-0')
      if(unsetModal) unsetModal()
      if(callback) callback(index)
    }, 300)

    if(player){
      if(player.tagName === 'VIDEO'){
        player.pause()
        player.currentTime = 0
      }
    }
  }

  const params = {
    id: "player", 
    width: width,
    height: height,  
    frameborder: 0,
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: true,
    autoplay: true, 
    controls: true, 
    class: "object-cover bg-gray-900 relative z-20",
    style: "max-width:80vw"
  }
</script>
<aside data-modal class="transition ease-in-out fixed top-0 left-0 w-screen h-screen z-50 flex justify-center items-center hidden">
  <div class="fixed top-0 left-0 w-screen h-screen bg-obsidian-90 z-0" on:click={closeModal}></div>
  <button class="transition hover:animate-pulse ease-in-out absolute z-20 right-10 top-10 p-4 cursor-pointer text-4xl text-white leading-4 hover:text-poppy focus:ring focus:text-poppy focus:ring-poppy" on:click={closeModal}>&times;</button>
  {#if url}
  <video {...params} data-src={url}>
    <track kind="captions">
    <source src={url} type="video/mp4">
  </video>
  {/if}
</aside>